import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

export const AnalyticsEmptyState: FunctionComponent = () => {
	const { t } = useTranslation();

	return (
		<div className="w-full max-w-5xl border border-dashed border-border-light rounded-xl bg-brand-white p-10 mt-6 flex flex-col items-center justify-center text-center">
			<div className="text-base font-semibold text-text">{t("analytics.emptyTitle")}</div>
			<div className="text-sm text-text-meta mt-1">{t("analytics.emptyBody")}</div>
		</div>
	);
};
